export class CatalogType{
    code: string;
    value: string;
}